import * as React from 'react';
import { Pie, Doughnut } from 'react-chartjs-2';
import Chartify from  '@shipsy/chartify';

class PieViz extends React.PureComponent<any, any> {

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.PieData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return formData && formData.doughnut ? (
      <Doughnut data={chartifyData.data} options={chartifyData.options} />
    ) : (
      <Pie data={chartifyData.data} options={chartifyData.options} />
    );
  }
}

export default PieViz;
